import debounce from 'lodash/debounce';
import FacebookLoader from './facebook-loader.jquery.js';
import '../in-viewport.jquery.js';

;(function($, window, document, undefined) {
  const pluginName = 'fbPagePlugin';

  class FacebookPagePlugin {
    constructor(element, options) {
      this.name = pluginName;
      this._defaults = $.fn[pluginName].defaults;
      this.element = element;
      this.options = $.extend({}, this._defaults, options);

      this.init();
    }

    init() {
      this.loader = new FacebookLoader(this.options.loaderItems);

      this.cacheElements();
      this.bindEvents();

      if (this.options.autoRender) {
        this.render();
      }
    }

    cacheElements() {
      this.$element = $(this.element);

      var limiterSelector = this.$element.data('fbPagePluginLimiter');

      if (!this.options.limiter && limiterSelector) {
        this.$limiter = $(limiterSelector);
      }
    }

    bindEvents() {
      window.FB.Event.subscribe('xfbml.render', this.finishLoading.bind(this));

      $(window)
        .on({
          resize: function(event) {
            this.render(true);
          }.bind(this),
          scroll: debounce(function () {
            if ($.inViewport(this.$element)) {
              this.render();
            }
          }.bind(this), 200)
        });

      $(document).on('fbPagePlugin:render', this.render.bind(this));
    }

    startLoading() {
      this.$element.prepend(this.loader.$element);
    }

    finishLoading() {
      if (this.$element.data('rendered')) {
        this.loader.$element.remove();
      }
    }

    render(force) {
      if (this.$element.data('rendered') && !force) {
        return;
      }

      this.$element.data('rendered', true);
      this.startLoading();
      window.FB.XFBML.parse(this.$element[0]);
    }
  }

  $.fn[pluginName] = function(options) {
    return this.each(function() {
      if (!$.data(this, `plugin_${pluginName}`)) {
        $.data(this, `plugin_${pluginName}`, new FacebookPagePlugin(this, options));
      }
    });
  };

  $.fn[pluginName].defaults = {
    autoRender: true,
    heightAdjustment: 16,
    loaderItems: 1
  };


})(jQuery, window, document);
